jQuery(document).ready(function ($) {
  $('.cm_team_4:not(.slider4) .slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });
  //4 Images in Desktop
  $('.cm_team_4.slider4 .slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      }
    ]
  });

  //hover box fade arrows
  $(".pagination_img_wrapper").on("mouseenter", function () {
    if ($(window).width() < 1440) {
      $(".slick-arrow").css("opacity", "0.1");
    }
  });
  $(".pagination_img_wrapper").on("mouseleave", function () {
    if ($(window).width() < 1440) {
      $(".slick-arrow").css("opacity", "0.9");
    }
  });
  //touch in mobile device
  if ($(window).width() < 768) {
    $(".pagination_img_wrapper").on("touchstart click", function (e) {
      e.preventDefault();
      $(".pagination_img_wrapper").not($(this)).removeClass("active_box");
      $(this).toggleClass("active_box");
      if ($(this).hasClass("active_box")) {
        $(".slick-arrow").css("opacity", "0.1");
      } else {
        $(".slick-arrow").css("opacity", "0.9");
      }
    });
    $(".pagination_img_wrapper .body_text a").on('click touchstart', function(e) {
      e.preventDefault();
      window.open($(this).attr("href"), '_target');
    });
  }
  //

  // $(".pagination_img_wrapper").on('touchmove', function(e) {
  //   e.preventDefault();
  //   });
  // $(".pagination_img_wrapper").on('touchstart', function() {
  //   documentClick = true;
  // });
  // $(".pagination_img_wrapper").on('touchmove', function() {
  //   documentClick = false;
  // });
  // $(".pagination_img_wrapper").on('click touchend', function(e) {
  //   e.preventDefault();
  //   if (e.type == "click") documentClick = true;
  //   if (documentClick){
  //     $(".pagination_img_wrapper").not($(this)).removeClass("active_box");
  //     $(this).toggleClass("active_box");
  //     if($(this).hasClass("active_box")){
  //       $(".slick-arrow").css("opacity", "0.1");
  //     }else {
  //       $(".slick-arrow").css("opacity", "0.9");
  //     }
  //   }
  // });
  $(document).on('click', function (event) {
    $(".pagination_img_wrapper").removeClass("active_box");
    $(".slick-arrow").css("opacity", "0.9");
  });
  //
});
